/**
 * @generated SignedSource<<a27c8604be208843cc1a0e8052a82427>>
 * @relayHash 888781c9fe90b2f4e05676de22fb5522
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubBootstrapWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  isDraft?: boolean | null;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  skipPageMediaConfig: boolean;
};
export type hubBootstrapWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubBootstrapWrapperQuery = {
  response: hubBootstrapWrapperQuery$data;
  variables: hubBootstrapWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPageMediaConfig"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v9 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "cornerRadius"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "pageAri",
                "variableName": "pageAri"
              },
              {
                "kind": "Variable",
                "name": "skipPageMediaConfig",
                "variableName": "skipPageMediaConfig"
              }
            ],
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "condition": "skipPageMediaConfig",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "pageMediaConfig",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "ari",
                    "variableName": "pageAri"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "concreteType": "HelpCenterMediaConfig",
                "kind": "LinkedField",
                "name": "hubMediaConfig",
                "plural": false,
                "selections": (v10/*: any*/)
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "default"
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "secondaryColor"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "backgroundColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderType"
                          },
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "padding"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "positionType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "textColor"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingTypography",
                        "kind": "LinkedField",
                        "name": "typography",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "headingFont"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "bodyFont"
                          }
                        ]
                      },
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "spaceDensity"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a",
    "metadata": {},
    "name": "hubBootstrapWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "86640fbb58e4cc03ace693195e50e046";

export default node;
